import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import fiCommon from './locales/fi/common.json';
import esCommon from './locales/es/common.json';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fi', label: 'Suomi',   flag: '🇫🇮' },
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number]['code'];

export const LOCALE_STORAGE_KEY = 'enska.ui.lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      fi: { common: fiCommon },
      es: { common: esCommon },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['en', 'fi', 'es'],
    // Detection order: our localStorage key → browser language → fallback
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;

/**
 * Resolve the effective locale to use at login time.
 * Priority: user.preferredLocale > tenant.defaultLocale > browser > 'en'
 */
export function resolveLocale(
  preferredLocale: string | null | undefined,
  tenantDefaultLocale: string | undefined,
): string {
  const supported = ['en', 'fi', 'es'];
  if (preferredLocale && supported.includes(preferredLocale)) return preferredLocale;
  if (tenantDefaultLocale && supported.includes(tenantDefaultLocale)) return tenantDefaultLocale;
  const browser = navigator.language.split('-')[0];
  if (supported.includes(browser)) return browser;
  return 'en';
}
